import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './util';

export const ApiTags = {
    TITLES: 'Titles',
    GIVEAWAY_CODES: 'GiveawayCodes'
};

export const api = createApi({
    reducerPath: 'passportApi',

    baseQuery: axiosBaseQuery({}),

    tagTypes: Object.values(ApiTags),

    endpoints: () => ({})
});
